import React from 'react';
import { motion } from 'framer-motion';

const HeroSection = () => {
  const services = [
    "Graphic Designing",
    "Photography",
    "Videography"
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.5,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <section className="flex flex-col md:flex-row items-center justify-between bg-transparent p-6 md:p-12 mt-10 mx-auto max-w-6xl gap-8 md:gap-0 min-h-[60vh] font-sans">
      <div className="flex-1 flex flex-col justify-center items-start text-center md:text-left">
        <motion.h1 
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold mb-6 md:mb-8 leading-tight text-black"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          NY Concept Multimedia
        </motion.h1>
        <motion.div 
          className="text-gray-800 font-semibold mb-6 text-base md:text-lg"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {services.map((service, index) => (
            <motion.span
              key={service}
              variants={itemVariants}
              className="inline-block mr-2"
            >
              {service}
              {index < services.length - 1 && (
                <motion.span
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.2 }}
                  className="mx-2"
                >
                  •
                </motion.span>
              )}
            </motion.span>
          ))}
        </motion.div>
        <motion.a
          href="https://wa.me/+233202522357?text=Hello Welcome To NY Concept"
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          whileHover={{ scale: 1.07, boxShadow: '0 8px 32px rgba(0,0,0,0.15)' }}
          whileTap={{ scale: 0.97 }}
          transition={{ duration: 0.7, delay: 0.6 }}
          className="mt-4 text-xl md:text-2xl font-bold text-black bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 rounded-lg px-6 py-4 shadow text-center cursor-pointer transition relative overflow-hidden group"
          style={{ display: 'inline-block' }}
        >
          <span className="relative z-10">Start Your Creative Journey</span>
          <span className="absolute left-1/2 bottom-2 w-0 h-1 bg-white rounded-full group-hover:w-4/5 transition-all duration-500 ease-out -translate-x-1/2" />
        </motion.a>
      </div>
      <motion.div 
        className="flex-1 flex justify-center items-center mt-8 md:mt-0"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, delay: 0.4 }}
      >
        <div className="bg-white rounded-xl shadow-lg p-4 md:p-8 flex items-center justify-center w-48 h-48 sm:w-64 sm:h-64 md:w-full md:h-auto">
          <img src="/img/home/daniel.jpg" alt="Photographer" className="w-full max-w-xs md:max-w-sm h-auto object-cover rounded-lg grayscale" />
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection; 